import { Fragment, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useHistory, Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import WeekSelect from "src/components/common/frame/weekSelect";
import DataFilter from "src/components/common/frame/dataFilter";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, 
    getDatefromWeekNum, 
    MyDate, 
    myAxios, 
    MyFormData, 
    getTimeStamp, 
    boolAndReducer, 
    scroll, 
    isDevMode,
    appTitle, 
    simpleStatusColorCode, 

    mimeTypeMap, 
    dateDurationCalc, 
} from "src/components/common/functions";
import Detail from "./detail";
import PerDiemForm from "./perDiemForm";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function PerDiem({ tabTitle }){
    const dataFrame = [
        {label: "Void", key: "void", type: "select", options: [{value: "", label: "No"}, {value: "All", label: "All"}, {value: "yes", label: "Yes"}]}, 
        {label: "Request Date", key: "requestDate", type: "date"}, 
        {label: "Requester", key: "requester"}, 
        {label: "Department", key: "department"}, 
        {label: "Project", key: "project"}, 
        {label: "Approver", key: "approver"}, 
        {label: "Status", key: "status", extraData: ["All-Submitted"]}
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key,  item.default?item.default:""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const allPerDiems = useMyStore(state => state.perDiems);
    const setPerDiems = useMyStore(state => state.setPerDiems);
    const projectNames = useMyStore(state => state.projectNames);
    const setProjects = useMyStore(state => state.setProjectNames);
    const userNames = useMyStore(state => state.perDiemUserNames);
    const setUsers = useMyStore(state => state.setPerDiemUserNames);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname + (history.location.hash ?? "");
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    const path3 = decodeURIComponent(path.split("/")[3] ?? ""); // "Edit"
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Per Diems": allPerDiems.updatedAt === null?getTimeStamp():allPerDiems.updatedAt, 
        "Users": userNames.updatedAt === null?getTimeStamp():userNames.updatedAt, 
        "Projects": projectNames.updatedAt === null?getTimeStamp():projectNames.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [curApproval, setApproval] = useState(""); 
    const [showLoading, setShowLoading] = useState(false);
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [curFilter, setFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //-------------------------------------------------------------------------------------------- 
    const projects = projectNames.data;
    const users = userNames.data;
    const perDiems = allPerDiems.data.filter(perDiem => 
        (perDiem.submitTime > getDatefromWeekNum(curWeekStart, 0)) &&  
        (perDiem.submitTime < getDatefromWeekNum(curWeekEnd, 7))
    ).map(perDiem => ({...perDiem, 
        requestDates: perDiem.startDate === perDiem.endDate?perDiem.startDate:perDiem.startDate + " ~ " + perDiem.endDate, 
        projectName: projects.filter(p => p.projectHashKey === perDiem.projectHashKey).length?
        projects.filter(p => p.projectHashKey === perDiem.projectHashKey)[0].projectName:"",
        creator: users.filter(uu => uu.email === perDiem.email).length?
        users.filter(uu => uu.email === perDiem.email)[0].userName:"",
    }));
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredPerDiems = perDiems.filter(perDiem => 
        (["all", "paid"].includes(user.perDiem)?true:user.email === perDiem.email)
        
        && (curWeekStart?(weeknum(perDiem.submitTime.substring(0, 10)) >= curWeekStart):true)
        && (curWeekEnd?(weeknum(perDiem.submitTime.substring(0, 10)) <= curWeekEnd):true)

        && (curFilter.void === "All"?true:(perDiem.void === curFilter.void))
        && (curFilter.requestDateMin?perDiem.startDate >= curFilter.requestDateMin:true)
        && (curFilter.requestDateMax?perDiem.endDate <= curFilter.requestDateMax:true)
        && (curFilter.requester?perDiem.email === curFilter.requester:true)
        && (curFilter.department?perDiem.department === curFilter.department:true)
        && (curFilter.project?perDiem.project === curFilter.project:true)
        && (curFilter.approver?perDiem.approver === curFilter.approver:true)
        && (curFilter.status?curFilter.status === "All-Submitted"?["Submitted", "Re-Submitted"].includes(perDiem.status):perDiem.status === curFilter.status:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(perDiem)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentPagePerDiems = filteredPerDiems.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredPerDiems.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const notify = async e => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const perDiemHashKey = e.currentTarget.id;
        const formData = new MyFormData();
        formData.append("perDiemHashKey", perDiemHashKey);
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios("perDiem/notify.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setPerDiems(
            curWeekStart, 
            curWeekEnd, 
            perDiems.map(thisPerDiem => thisPerDiem.perDiemHashKey === perDiemHashKey?{...thisPerDiem, 
                "notify": getTimeStamp()
            }:thisPerDiem)
        );
        history.replace(`/${path1}`);
        scroll(null);
    }
    //--------------------------------------------------------------------------------------------
    const voidPerDiem = async e => {
        if(!window.confirm("Are you sure to void this per diem?")) return;
        const perDiemHashKey = e.currentTarget.id;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("perDiemHashKey", perDiemHashKey);
        formData.append("voidReason", voidReason);
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios("perDiem/voidPerDiem.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setPerDiems(
            curWeekStart,
            curWeekEnd, 
            perDiems.map(thisPerDiem => thisPerDiem.perDiemHashKey === perDiemHashKey?{...thisPerDiem, 
                "void": "yes", 
            voidReason
            }:thisPerDiem)
        );
        history.replace(`/${path1}`);
        scroll(null);
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("UseEffect main");
            let realWeekStart = curWeekStart;
            let realWeekEnd = curWeekEnd;
            if(!["Add", ""].includes(path2)){
                const formData = new MyFormData();
                formData.append("perDiemHashKey", path2);
                setShowLoading(true);
                const perDiemRes = await myAxios("perDiem/readPerDiem.php", formData, undefined, controller.signal);
                if(!isMounted){
                    setShowLoading(false);
                    return;
                }
                if(!perDiemRes) return;
                const potentialPerDiem = perDiemRes.data;
                if(potentialPerDiem === ""){
                    history.replace(`/${path1}`);
                }else{
                    if(potentialPerDiem.void){setFilter(f => ({...f, void: "yes"}));}
                    realWeekStart = weeknum(potentialPerDiem.submitTime.substring(0, 10));
                    realWeekEnd = weeknum(potentialPerDiem.submitTime.substring(0, 10));
                    setWeekStart(realWeekStart);
                    setWeekEnd(realWeekEnd);
                }
            }
            const formData = new MyFormData();
            formData.append("access", user.perDiem);
            if(!(allPerDiems.weekStart && allPerDiems.weekEnd)){
                formData.append("start", getDatefromWeekNum(realWeekStart, 0));
                formData.append("end", getDatefromWeekNum(realWeekEnd, 7));
            }else if(allPerDiems.weekStart > realWeekStart && allPerDiems.weekEnd === realWeekEnd){
                formData.append("start", getDatefromWeekNum(realWeekStart, 0));
                formData.append("end", getDatefromWeekNum(allPerDiems.weekStart, 0));
            }else if(allPerDiems.weekStart === realWeekStart && allPerDiems.weekEnd < realWeekEnd){
                formData.append("start", getDatefromWeekNum(allPerDiems.weekEnd, 7));
                formData.append("end", getDatefromWeekNum(realWeekEnd, 7));
            }
            setShowLoading(true);
            const res = await myAxios("/perDiem/readPerDiems.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            const curPerDiems = [...res.data, ...allPerDiems.data].sort((a, b) => a.submitTime > b.submitTime?1:-1);
            setPerDiems(
                !allPerDiems.weekStart || realWeekStart < allPerDiems.weekStart ? curWeekStart : allPerDiems.weekStart, 
                !allPerDiems.weekEnd || realWeekEnd > allPerDiems.weekEnd ? realWeekEnd : allPerDiems.weekEnd, 
                curPerDiems, 
                updateDateTime["Per Diems"]
            );
        }
        if(
            !(
                allPerDiems.weekStart && 
                allPerDiems.weekEnd && 
                allPerDiems.weekStart <= curWeekStart && 
                allPerDiems.weekEnd >= curWeekEnd
            ) ||
            allPerDiems.updatedAt !== updateDateTime["Per Diems"]
        ) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[curWeekStart, curWeekEnd, updateDateTime, allPerDiems, setPerDiems, history, path1, path2, user.perDiem])
    useEffect(() => {
        if(updateDateTime["Users"] === userNames.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect side users");
            setShowLoading(true);
            const resUserNames = await myAxios("perDiem/readUserNames.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resUserNames) return;
            setUsers(
                resUserNames.data, 
                updateDateTime["Users"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [updateDateTime, setUsers, userNames.updatedAt]);
    useEffect(() => {
        if(updateDateTime["Projects"] === projectNames.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect side projects");
            setShowLoading(true);
            const resProjects = await myAxios("perDiem/readProjectNames.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resProjects) return;
            //-----------------------------------
            setProjects(
                resProjects.data, 
                updateDateTime["Projects"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [updateDateTime, setProjects, projectNames.updatedAt]);
    useEffect(() => {
        if(!["Add", ""].includes(path2)){
            const thisPerDiem = filteredPerDiems.find(perDiem => perDiem.perDiemHashKey === path2);
            if(!thisPerDiem){
                setCurrentPage(1);
                return;
            }
            const hashkeys = filteredPerDiems
            .filter(filteredPerDiem => filteredPerDiem.void === thisPerDiem.void)
            .map(filteredPerDiem => filteredPerDiem.perDiemHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [filteredPerDiems, itemsPerPage, path2])
    useEffect(() => {
        if(path2){
            if(path3 !== "Edit") history.replace(`/${path1}/${path2}`);
            else history.replace(`/${path1}/${path2}/Edit`);
        }
    },[history, path1, path2, path3])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                
                {filteredPerDiems.find(filteredPerDiem => filteredPerDiem.approverEmail === user.email)?
                <span className = "d-flex align-items-center">
                    <label htmlFor = "approval" className = "mb-0">Approval:</label>
                    <select
                        id = "approval"
                        className = "form-control w-auto ml-2"
                        value = {curApproval} 
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setApproval(value);
                            if(value === ""){
                                setFilter({...curFilter, approver: "", status: ""});
                            }else if(value === "all"){
                                setFilter({...curFilter, approver: user.userName, status: ""});
                            }else if(value === "need"){
                                setFilter({...curFilter, approver: user.userName, status: "All-Submitted"});
                            }
                            history.push(`/${path1}`);
                            setCurrentPage(1);
                        }}
                    >
                        <option value = "">All Per Diems</option>
                        <option value = "all">All My Approval</option>
                        <option value = "need">Need My Approval</option>
                    </select>
                </span>
                :<></>}
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {path1}
                    beginWeek = "2022/1/24"
                />
                <DataFilter
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    items = {perDiems}
                    dataFrame = {dataFrame}
                    width = {"60rem"}
                    minWidth = {"40rem"}
                />
                <Export
                    filteredPerDiems = {filteredPerDiems}
                />
                {["yes", "all"].includes(user.perDiem)?
                <button type = "button" className = "headerButton" onClick = {() => history.push(`/${path1}/Add`)}>
                    Add
                </button>
                :null}
                {path2 === "Add" && users.length && projects.length?
                <PerDiemForm
                    keyword = "Add"
                    history = {history}
                    closeIt = {() => history.push(`/${path1}`)}
                    curWeekStart = {curWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setPerDiems = {setPerDiems}
                    users = {users} 
                    projects = {projects}
                    perDiems = {perDiems}
                />:null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredPerDiems.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                {["all", "paid"].includes(user.perDiem)?<>
                                <th></th>
                                <th>Employee Name</th>
                                <th>Department</th>
                                </>:null}
                                <th>BTL Number</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Duration</th>
                                <th>Hotel Name</th>
                                <th>Hotel Address</th>
                                <th>Submit Time ↑</th>
                                <th>Approver</th>
                                <th>Status</th>
                                <th></th>
                                {user.perDiem === "paid"?<>
                                <th>Paid</th>
                                <th>
                                    <span></span>
                                </th>
                                </>:null}
                            </tr>
                        </thead>
                        <tbody>
                            {currentPagePerDiems.map((perDiem, key) => 
                            <Fragment key = {key}>
                            <tr id = {perDiem.perDiemHashKey}
                            style = {{color: simpleStatusColorCode[perDiem.status]}}>
                                {["all", "paid"].includes(user.perDiem)?<>
                                <td>
                                    <button
                                        id = {perDiem.perDiemHashKey}
                                        onClick = {e => {
                                            if((user.perDiem === "all"|| user.perDiem === "paid" || [perDiem.email, perDiem.approverEmail, perDiem.projectHashKey].includes(user.email)) && path2 !== e.currentTarget.id){
                                                history.push(`/${path1}/${e.currentTarget.id}`);
                                                scroll(e.currentTarget.id);
                                            }else{
                                                history.push(`/${path1}`);
                                                scroll(null);
                                            }
                                        }}
                                        className = {(path2 === perDiem.perDiemHashKey?"showMinus":"showPlus") + " childRow"}
                                    />
                                </td>
                                <td id = {perDiem.email}>
                                    <UserInfo 
                                        name = {perDiem.requester}
                                        email = {perDiem.email}
                                    />
                                </td>
                                <td>{perDiem.department}</td>
                                </>:null}
                                <th><Link to = {`/Projects/${perDiem.projectHashKey}`}>{perDiem.project}</Link></th>
                                <td>{perDiem.startDate}</td>
                                <td>{perDiem.endDate}</td>

                                <td>{dateDurationCalc(perDiem.startDate, perDiem.endDate, "date")}</td>
                                <td>{perDiem.hotelName}</td>
                                <td>{perDiem.hotelAddress}</td>
                                <td>{perDiem.submitTime}</td>
                                <td>
                                    <UserInfo 
                                        name = {perDiem.approver}
                                        email = {perDiem.approverEmail}
                                    />
                                </td>
                                <td>{perDiem.status}</td>
                                <td>
                                    {[perDiem.email, perDiem.approverEmail].includes(user.email) || user.perDiem === "all" || user.perDiem === "paid"?
                                    <button type = "button" id = {perDiem.formId} className = "btn btn-success" onClick = {async() => {
                                        if(!perDiem.formId){
                                            window.alert("PDF Error.");
                                            return
                                        }
                                        const formData = new MyFormData();
                                        formData.append("fileId[]", perDiem.formId);
                                        //-----------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/getFile.php", formData, "blob");
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-----------------------------------
                                        const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                        saveAs(file, `Per Diem Request - ${perDiem.requester} ${perDiem.projectName} ${perDiem.requestDates}.pdf`);
                                    }}>Form</button>
                                    :null}
                                </td>
                                {user.perDiem === "paid"?<>
                                <td>{perDiem.paid}</td>
                                <td><span className = {`btn btn-${perDiem.paid?"danger":"primary"}`} onClick = {async() => {
                                    if(!window.confirm(`Are you sure to Set this per diem ${perDiem.paid?"unpaid":"paid"}?`)) return;
                                    const formData = new MyFormData();
                                    formData.append("perDiemHashKey", perDiem.perDiemHashKey);
                                    formData.append("paid", perDiem.paid?"":"yes");
                                    //-----------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("perDiem/paid.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //-----------------------------------
                                    setPerDiems(
                                        curWeekStart, 
                                        curWeekEnd, 
                                        perDiems.map(thisPerDiem => thisPerDiem.perDiemHashKey === perDiem.perDiemHashKey?{...thisPerDiem, 
                                            "paid": perDiem.paid?"":"yes"
                                        }:thisPerDiem)
                                    );
                                    history.replace(`/${path1}`);
                                    scroll(null);
                                }}>{perDiem.paid?"Set Unpaid":"Set Paid"}</span></td>
                                </>:null}
                                
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight
                                        classNames = "cssTDTransition"
                                        In = {(user.perDiem === "all" || user.perDiem === "paid" || [perDiem.email, perDiem.approverEmail].includes(user.email)) && path2 ===  perDiem.perDiemHashKey}
                                    >
                                        <Detail
                                            curWeekStart = {curWeekStart}
                                            curWeekEnd = {curWeekEnd}
                                            setPerDiems = {setPerDiems}
                                            perDiems = {perDiems}
                                            path1 = {path1}
                                            path2 = {path2}
                                            path3 = {path3}
                                            perDiem = {perDiem}
                                            history = {history}
                                            users = {users}
                                            projects = {projects}
                                            notify = {notify}
                                            voidPerDiem = {voidPerDiem}
                                            setShowLoader = {setShowLoader}
                                            user = {user}
                                        />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredPerDiems.length?
                <Footer
                    length = {filteredPerDiems.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}